import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Projects from './components/Projects';
import './css/main.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <Projects />
    </div>
  );
}

export default App;
